<script setup lang="ts">
import { useReCaptcha } from 'vue-recaptcha-v3'
const recaptchaInstance = useReCaptcha()

onMounted(() => {
  recaptchaInstance?.instance.value?.showBadge()
})
onBeforeUnmount(() => {
  recaptchaInstance?.instance.value?.hideBadge()
})
</script>
<template>
  <span />
</template>

<style lang="scss" scoped>
.recaptcha-info {
  margin-block: 50px;
}
</style>
